import React from 'react'
import Pencil from '../icons/Pencil'
import { LessonPlan } from '../types'
import { Link, useParams } from 'react-router-dom'
import RemoveLessonPlanButton from './RemoveLessonPlanButton'

interface Props {
  item: LessonPlan
}

const LessonPlanListItem = ({ item }: Props) => {
  const { unitId } = useParams()
  return (
    <div className="flex items-center justify-between border-2 border-gray-200 p-4 rounded-md cursor-pointer">
      <div className="flex items-center gap-2">
        <div className="text-14 font-semibold">Lesson: {item.name}</div>
        <div className="text-14 font-semibold">Position: {item.position}</div>
        <div className="text-14 font-semibold">Slides: 10</div>
      </div>
      <div className="flex items-center gap-2">
        <Link
          to={`/units/${unitId}/lesson_plans/${item.id}`}
          className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer mt-2 z-10">
          <div className="text-white w-5 h-5">
            <Pencil />
          </div>
          <div className="text-14 font-semibold text-white">Edit</div>
        </Link>
        <RemoveLessonPlanButton lessonPlanId={item.id} unitId={Number(unitId)} />
      </div>
    </div>
  )
}

export default LessonPlanListItem
